import { lazy } from "react";
import { Navigate } from "react-router-dom";
/****Layouts*****/

const ServiceLogLayout = lazy(() => import("../layouts/ServiceLogLayout.js"));
const DatabaseLayout = lazy(() => import("../layouts/DatabaseLayout.js"));
const AppSettingsLayout = lazy(() => import("../layouts/AppSettingsLayout.js"));

/*****Routes******/

/**Pages*/
const ServiceLogView = lazy(() => import("../views/serviceLogs/ServiceLogView.js"));
const DatabaseLogView = lazy(() => import("../views/DatabaseLogView.js"));
const AppTagSettingsView = lazy(() => import("../views/appSettings/AppTagSettingsView.js"));

const ThemeRoutes = [
  {
    path: "/",
    element: <Navigate to="/service" replace />,
    children: [
      { path: "", exact: true, element: <ServiceLogView /> }
    ],
  },
  {
    path: "/service",
    element: <DatabaseLayout/>,
    children: [
      { path: "", exact: true, element: <ServiceLogView /> }
    ],
  },
  {
    path: "/database",
    element: <DatabaseLayout/>,
    children: [
      { path: "", exact: true, element: <DatabaseLogView /> }
    ],
  },
  {
    path: "/apps",
    element: <DatabaseLayout/>,
    children: [
      { path: "", exact: true, element: <AppTagSettingsView /> }
    ],
  }


  
];

export default ThemeRoutes;
